module.exports = __webpack_public_path__ + "static/EnmTX_BosErhardt_L_A_cl-f2108a054c8f5b5c825cd83231483f24.gif";